import { formatUIDateTime } from "utils/helpers"

export const toTableRowItems = (items: DSMetiFile[]) =>
  items.map((item: DSMetiFile) => ({
    id: item.id,
    shopCode: item.shopCode || '',
    orderNumber: item.orderNumber,
    orderId: item.orderId,
    supplierName: item.supplierName || '',
    supplierCode: item.supplierCode || '',
    integrationStatus: item.integrationStatus || '',
    integrationStatusValue: item.integrationStatusValue,
    created: item.created || '',
    sentTime: formatUIDateTime(item.sentTime) || '',
    hasError: item.hasError || false,
    hasDifference: item.hasDifference || false,
    hasMetiDifference: item.hasMetiDifference || false,
    integrated: item.integrated || false
  }))
